import { useEffect } from "react";

export const useNuanceBucket = () => {
  useEffect(() => {
    const param = localStorage.getItem("chat");

    if (param === "nuance") {
      const url = new URL(window.location.href);
      const hasParam =
        url.searchParams.get("featuresForceVariation") === "EMF-1090727:1";

      if (!hasParam) {
        url.searchParams.set("featuresForceVariation", "EMF-1090727:1");

        window.location.href = url.toString();
      }
    }
  }, []);
};
